//引入对应模块
import Vue from 'vue'
import VueRouter from 'vue-router'

//首页对应的组件
import Home from '@/pages/Home/Home'

//评价对应的组件
import Evaluation from '@/pages/Evaluation/Evaluation'

// 购物车对应的页面
import ShoppingCat from '@/pages/ShoppingCat/ShoppingCat'

// 砍价列表
import BargainList from '@/pages/Bargain/List'
// 砍价订单
import BargainOrder from '@/pages/Bargain/Order'
// 正在砍价
import Bargaining from '@/pages/Bargain/Bargaining'
// 活动规则
import BargainRule from '@/pages/Bargain/Rule'

// 订单页
import Order from '@/pages/Order/Order'
// 收获地址
import Address from '@/pages/Address/Address'
// 拼团商城组件
// 拼团栏目页
import GroupList from '@/pages/FightGroups/GroupList'

//声明使用
Vue.use(VueRouter);



//输出路由对象
export default new VueRouter({
  mode : 'history',
  base : '/V',
  routes: [
    // 首页
    {
      path: '/*/wap_pro/*.html',
      // path: '/home',
      name: 'Home',
      component: Home,
    },
    // 评价页
    {
      path: '/evaluation',
      name: 'evaluation',
      component: Evaluation,
    },
    // 购物车
    {
      path: '/shoppingCat',
      name: 'shoppingCat',
      component: ShoppingCat,
    },
     // 订单
     {
      path:'/order',
      name:'order',
      component: Order
    },
    // 收获地址
    {
      path:'/address',
      name:'address',
      component: Address
    },
    // 砍价列表页
    {
      path: '/bargainList',
      name: 'bargainList',
      component: BargainList,
    },
    //砍价订单
    {
      path: '/bargainOrder',
      name: 'bargainOrder',
      component: BargainOrder,
    },
    // 正在砍价
    {
      path: '/bargaining',
      name: 'bargaining',
      component: Bargaining,
    },
    // 活动规则
    {
      path: '/bargainRule',
      name: 'bargainRule',
      component: BargainRule,
    },
    // 拼团商城
    {
      path: '/fightGroup',
      component: GroupList,
      children: [
        {
          path: 'groupList', // 默认路由: 拼团栏目页
          name: 'groupList',
          component: GroupList
        }
      ]
    },
    {
      path: '*',
      name: 'home',
      //当用户访问莫名其妙的链接或者找不到时，就返回首页
      redirect: '/home'
      // component: Home,
    },
  ]
});




// WEBPACK FOOTER //
// ./src/router/index.js